import { render, staticRenderFns } from "./onoffList.vue?vue&type=template&id=f6b1aa3c&scoped=true&"
import script from "./onoffList.vue?vue&type=script&lang=js&"
export * from "./onoffList.vue?vue&type=script&lang=js&"
import style0 from "./onoffList.vue?vue&type=style&index=0&id=f6b1aa3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b1aa3c",
  null
  
)

export default component.exports